const ChartColors = [
    'rgba(255, 99, 132)', '#b8e4ff', '#d0fdd7', '#ffe4ea', "rgba(20, 160, 193, 0.8)", '#ffe180',
    '#caacf9', "#ecd6c0", "#96c4c4",
    '#13AB86', '#17D3A4', '#30E8BA', '#6EEFCF', '#C1F8EA', '#EAFDF8',
    '#3e5f8a', '#5783bc', '#6a9cde', '#a0c5f7', '#cadffb',
    '#005227', '#038554', '#03bb85', '#68ddbd', '#a4fff7',
    '#005954', '#338b85', '#5dc1b9', '#9ce0db', '#d5ffff',
    '#d0fdd7', '#9bfab0', '#64c27b', '#2a8c4a', '#D8F0E1',
];

export default ChartColors;